// extracted by mini-css-extract-plugin
export default {"badgeContainer":"badgeContainer--Wa2jc"};